<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
  onMounted(async () => {
    useLinksToTargetParent(document)
  })
  onUnmounted(async () => {
    useLinksToTargetParent(null)
  })
</script>